import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message , Tag} from 'antd';

const tagType = ['red', 'green'];
const sendTypeText = ['手机', '微信', '邮箱', '平台'];
const businessTypeText = ['学生评价', '教师听课', '按名单提醒', '督导评价'];
const userTypeText = ['教师', '学生'];
const sendStatusText = ['未成功', '已发送'];

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号' , width: 75},
    {key:'senderOrgName', label: '发送人部门' , width: 120},
    {key:'senderCode', label: '发送人代码', width: 120},
    {key:'senderName', label: '发送人姓名' , width: 120 },
    {key:'receiverOrgName', label: '接收人部门' , width: 120},
    {key:'receiverCode', label: '接收人代码', width: 120},
    {key:'receiverName', label: '接收人姓名' , width: 120 },
    {key:'userType', label: '接收人类型', width: 100, render: (val) => {
        return userTypeText [val-1]
    }},
    {key:'sendTypeName', label: '发送类型', width: 100},
//     {key:'sendType', label: '发送类型', width: 100, render: (val) => {
//         return sendTypeText[val-1]
//     }},
    {key:'businessTypeName', label: '业务类型', width: 100},
//     {key:'businessType', label: '业务类型', width: 75, render: (val) => {
//         return businessTypeText[val-1]
//     }},
    {key:'sendStatus', label: '发送情况',width:100, render: (val) => {
        const type = tagType[val-1];
        return <Tag color={type}>{sendStatusText[val-1]}</Tag>
    } },
    {key:'createTime', label: '创建时间', width:100},
    {key:'termName', label : '所属学期'},
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;
    var params = [];
    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        }  else if(i === 'order'){
            params.push(`order=${keywords[i]}`);
        } else {
        }
    }

    return fetch.post('/message/query?'+ params.join('&'),  Object.assign(defaultsParams, keywords))
    // return fetch.mockget('http://test.gxjxcp.com:8888/mock/11/jxcp-webapp/listenManager')
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({ 
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearchTerm = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.get('listen/org/copy', keywords)
    .then(response => response.payload.meta.extParams || {})
    .then(params => params.lastTerm || {})
    .then(lastTerm => lastTerm.id)
}

/**
 * @method insert
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('/listen/assign/insert', data)
    .then(response => {
        if(response.code === 200) {
            message.success('温馨提示：添加成功！');
        }
    });
}

/**
 * @method copy
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const copy = (params) => {
    return fetch.post('listen/org/save/copy', params)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
            DataGrid.refresh();
        }
    }).catch(error => {
        return error;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (params) => {
    return fetch.post('/message/delete',params );
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (orgId) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove({orgId, ids: DataGrid.selections.join(',')}).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'listen/assign'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const update = (id , params)=>{
    return fetch.post('/listen/generate/update/' + id, params)
}


/**
 * @method querySearchByBusinessType
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByBusinessType = (keywords ={}) => {
    return fetch.post('/message/findBusinessType', keywords)
    .then(response => {
        return (response.payload.data || []).filter(d =>{
            return d !== null;
        }).map(d => ({
            value: d.businessType,
            label: d.businessTypeName
        }));
    });
}

export default {
    querySearch,
    insert,
    update,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    querySearchTerm,
    copy,
    getSelection,
    querySearchByBusinessType
}